// extracted by mini-css-extract-plugin
export default {"tagUnit":"tag-unit-module--tag-unit--2nEW3","tagValue":"tag-unit-module--tag-value--ACPv3","tagKey":"tag-unit-module--tag-key--1wzqN"};